import { resultPaginationReducerKey } from './ResultsPaginationConstants';

export function resultsPaginationComponent(state) {
  return state.get(resultPaginationReducerKey);
}

export function dropdownValues(state) {
  return resultsPaginationComponent(state)
    .get('dropdownValues');
}
